import React from "react";
import "./main.css";
import PageTitle from "./PageTitle";
import { useAuthStore } from "../../../store/store";
import navList from "../data/navItem";
import Dashboard from "./Dashboard/Dashboard";

function Main() {
  const { sectionId, subSection } = useAuthStore((state) => state.status);

  const section = navList.find((current) => current._id === sectionId);
  const sectionName = section?.name ?? "";
  const subSectionName = subSection?.name ?? "";

  return (
    <main id="main" className="main">
      <PageTitle page={sectionName} sectionName={subSectionName} />
      <Dashboard />
    </main>
  );
}

export default Main;
